document.addEventListener("DOMContentLoaded", function() {
    document.getElementById('phoneSubscriberSubmit').addEventListener('click', function() {
  
        // Checkbox validation
        const termsCheckbox = document.getElementById('phone_suscriber_terms_check');
        if (!termsCheckbox.checked) {
            document.getElementById('phoneSubscriberMessage').innerText = 'Please agree to the terms before subscribing';
            document.getElementById('phoneSubscriberMessage').style.color = 'red';
            return; // Exit the function if the checkbox is not checked
        }
  
        var phoneNumber = document.getElementById('phoneSubscriberInput').value;
        if (phoneNumber && phoneNumber.replace(/[^0-9]/g, '').length) {
            var xhr = new XMLHttpRequest();
            xhr.open('POST', 'https://tranquil-meadow-58540-f89f8eb2edc7.herokuapp.com/api/subscribe', true);
            xhr.setRequestHeader('Content-Type', 'application/json');
            xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        document.getElementById('phoneSubscriberMessage').innerText = 'Thank you for subscribing';
                        document.getElementById('phoneSubscriberMessage').style.color = 'green';
                        document.getElementById('phoneSubscriberInput').value = '';
                    } else {
                        document.getElementById('phoneSubscriberMessage').innerText = 'Failed to subscribe';
                        document.getElementById('phoneSubscriberMessage').style.color = 'red';
                    }
                }
            };
            xhr.send(JSON.stringify({ phone: phoneNumber }));
        } else {
            document.getElementById('phoneSubscriberMessage').innerText = 'Please enter a valid phone number';
            document.getElementById('phoneSubscriberMessage').style.color = 'red';
        }
    });
  });